import { useMemo, useState } from 'react';
import { observer } from '@formily/reactive-react';
import Editor from '../../../components/Editor/Editor';
import { type IFormFieldSchema } from '../../types';
import { buildEditorConfig } from './buildEditorConfig';
import type { IFormEditorProps } from './index';
import useInitEditor from './useInitEditor';

interface IProps {
  schema: IFormFieldSchema<IFormEditorProps>;
}

const FormEditor = observer(({ schema }: IProps) => {
  const componentProps = (schema['x-component-props'] ||
    {}) as IFormEditorProps;
  const [value, setValue] = useState<string>('');

  const editorConfig = useMemo(
    () => buildEditorConfig(componentProps),
    [
      componentProps.height,
      componentProps.placeholder,
      componentProps.menubar,
      componentProps.statusbar,
      componentProps.branding,
      componentProps.toolbarGroups,
    ]
  );

  const handleEditorInit = useInitEditor({
    componentProps,
    handleChange: () => {},
  });

  if (componentProps.visible === false) return null;

  return (
    <Editor
      value={value}
      onChange={setValue}
      disabled={componentProps.disabled}
      config={editorConfig}
      onEditorInit={handleEditorInit}
    />
  );
});

export default FormEditor;
